import React from 'react'
import AdminReviewList from '../../components/AdminSideComponents/DashBoardReview/AdminReviewList'

const Review = () => {
  return (
    <div className='bg-[#EEF3F7] p-6'>
      <AdminReviewList />
    </div>
  )
}

export default Review